import React from "react"
import { Menu } from "dash-styled"
import { TableColumn } from "resha"
import { ReactComponent as IconGear } from "icons/lib/gear.svg"
import {
    enumFilter,
    FilterFields
} from "../../../../../Common/FilterComposer/FilterComposer"
import {
    FilterExpression,
    UnaryFilterOperator
} from "../../../../../../Models/Client/FilterExpression"
import { SortOptionField } from "../../../../../Common/Button/SortChooser"
import { SortExpression } from "../../../../../../Models/Client/SortExpression"
import {
    APIOrgMember,
    APIOrgMemberRole,
    apiOrgMemberRoleList
} from "../../../../../../Models/API/APIOrgMember"
import capitalize from "lodash/capitalize"

const roles: { [label: string]: APIOrgMemberRole } = Object.values(
    apiOrgMemberRoleList
).reduce((accum, type) => {
    accum[type] = type
    return accum
}, {} as { [label: string]: APIOrgMemberRole })

export const orgMemberFilters: FilterFields<APIOrgMember> = {
    role: enumFilter("Role", roles, (a, b) => a === b, false)
}

export const defaultOrgMemberFilter: FilterExpression<APIOrgMember> = {
    fieldName: "orgUsername",
    operator: UnaryFilterOperator.contains,
    value: ""
}

export const orgMemberSortOptions: SortOptionField<APIOrgMember>[] = [
    {
        field: "userEmail",
        label: "Email",
        ascLabel: "Alphabetical",
        descLabel: "Reverse alphabetical"
    },
    {
        field: "role",
        label: "Role",
        ascLabel: "Alphabetical",
        descLabel: "Reverse alphabetical"
    },
    {
        field: "created",
        label: "Created",
        ascLabel: "Oldest first",
        descLabel: "Youngest first"
    }
]

export const defaultOrgMemberSort: SortExpression<APIOrgMember> = {
    sortBy: "userEmail",
    desc: false
}

export function memberColumns<T extends string>(
    menuItems: (model: APIOrgMember) => T[],
    myEmail: string,
    onSelectMenu: (selected: T, userId: number) => void
): TableColumn<APIOrgMember>[] {
    return [
        {
            renderHeader: () => "Email",
            render: ({ userEmail }) => (
                <>
                    {userEmail}
                    {myEmail === userEmail ? (
                        <span className="ml-1 italic">(you)</span>
                    ) : (
                        ""
                    )}
                </>
            )
        },
        {
            renderHeader: () => "Role",
            render: ({ role }) => capitalize(role)
        },
        {
            renderHeader: () => "Status",
            render: ({ status }) => capitalize(status)
        },
        {
            className: "w-24",
            renderHeader: () => "Modify",
            render: model => {
                const items = menuItems(model)

                return (
                    <Menu
                        title={<IconGear className="w-4 h-4 -mt-px mr-3" />}
                        className="-my-1"
                        align="right"
                        nonInteractive={false}
                        disabled={items.length === 0}
                        items={items}
                        onChoose={selected => onSelectMenu(selected, model.id)}
                    />
                )
            }
        }
    ]
}
